import { allTrackers } from "app/services/track/track";
import createEnrichmentTrackingService from "./factory";

const enrichmentTrackingService = createEnrichmentTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default enrichmentTrackingService;
